<template>
 <div class="app" style="width: 100%;">
	  <el-container direction="vertical">
	      <el-header style="padding:0;height: auto;">
	        <IndexHead></IndexHead>
	      </el-header>
	      <el-main style="padding:0;">
				<div  v-show="isxiangqin" style="margin-top: 20px;">
					<el-row type="flex" justify="center">
						<el-col :span="22">
							<p style="font-size: 15px;text-align: left;"><span class="xiaoshou" @click="isxiangqin = false">行业动态</span> > <span>{{detailData.name}}</span></p>
						</el-col>
					</el-row>
				</div>
			  <div class="text color flex justify-align-center" style="font-size: 23px;height:85px;margin-top: 10px;">
			    行业动态
			  </div>
				<div id="" v-show="!isxiangqin">
					<div class="content" style="width:50%;margin: 0 auto;">
					  <div v-for="(item,index) in dtlist" :key="index" class="flex align-center xiaoshou" style="border-bottom: 1px solid #aaaaaa;padding:10px 0;" @click="goDetail(index)">
						  <div class="backbg flex direction-column justify-align-center" style="color:#ffffff;min-width:70px;height:70px;">
							  <div style="font-size:28px;">{{item.publish_day}}</div>
							  <div style="font-size: 14px;">{{item.publish_year_month}}</div>
						  </div>
						  <div class="" style="margin-left: 10px;">
							  <div style="height:25px ;text-align: left;font-size:14px;">{{item.name}}</div>
							  <div class="font" style="color:#aaaaaa;line-height: 20px;text-align: left;">{{item.brief}}</div>
						  </div>
					  </div>
					</div>
					<div class="font flex all-justify-end align-center"
						style="width:50%;margin: 10px auto;text-align: end;">
						<el-pagination hide-on-single-page layout="prev, pager, next,jumper" :page-size="10" :total="total" :current-page="page" @current-change="currentPage">
						</el-pagination>
						<!-- <div class="flex" style="margin-left: 10px;">
							<div :class="page==1?'ye1 color':'ye1'" >1</div>
							<div class="ye2" @click="pages()">Go</div>
						</div> -->
					</div>
				</div>
			  <div v-show="isxiangqin">
					<el-row type="flex" justify="center">
						<el-col :span="18">
							<p style="text-align: center;margin: 20px 0;">{{detailData.name}}</p>
							<p style="text-align: right;font-size: 14px;color: #999999;margin-bottom: 20px;">{{detailData.created_at}}</p>
							<div class="fuwenben" v-html="detailData.content"></div>
						</el-col>
					</el-row>
				</div>
	      </el-main>
	     <el-footer style="padding:0;height: 30px;margin-top: 60px;width:100%;">
	     	<div class="font" style="width:100%;background: #282828;height: 50px;color:#ffffff;line-height: 50px;text-align: center;">
	     		版权所有：HR校招助手网  <span style="width: 100px;display: inline-block;"></span> CNZZ
	     	</div>
	     </el-footer>
	  </el-container>
		<div style="height: 50px;width: 100%;"></div>
  </div>
</template>

<script>
	import IndexHead from '../components/IndexHead.vue';
	export default {
		name: 'index',
		components:{
			IndexHead
		},
		data(){
		  return{
			  // 表格的页码
			  page:1,
			dtlist:[],
			total: 0,//数据总条数
			detailData: {},//详情内容
			isxiangqin: false,//是不是详情
		  }
		},
		mounted() {
			this.cooperat();
		},
		methods:{
			goDetail(index){
				this.isxiangqin = true;
				this.$axios.get('/api/article/detail?id=' + this.dtlist[index].id).then(res => {
					this.detailData = res.data.data;
				})
			},
			//页码
			pages(){
				if(this.page!=1){
					this.page=1;
					this.cooperat();
				}
			},
			currentPage(val){
				// console.log(val,"e");
				this.page=val;
				this.cooperat();
			},
			prevPage(){
				this.page--;
				this.cooperat();
				console.log(this.page,"prev");
			},
			nextPage(){
				this.page++;
				this.cooperat();
				console.log(this.page,"next");
			},
			cooperat(){
				this.$axios
					.get(`/api/articles?slug=news&page=${this.page}`)
					.then((res) => {
						// console.log(res,"res");
						this.dtlist=res.data.data.list;
						this.total = res.data.data.total
					});
			}
		}
	}
</script>
<style lang="less">
	#app {
	  font-family: Avenir, Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  // text-align: center;
	  color: #2c3e50;
	}
	#navs{
		display:flex;
		justify-content:space-around;
	}
	#nav {
	  a {
	    font-weight: bold;
	    color: #2c3e50;
	
	    &.router-link-exact-active {
	      color: #42b983;
	    }
	  }
	}
 .el-pager>li {
 	min-width: 24px !important;
 	height: 20px;
 	line-height: 20px;
 	border: 1px solid #EBEEF5;
 	margin: 5px;
 	font-size: 12px;
 	color: #999999;
 }
 
 .el-pager li.active {
 	color: #42b983;
 }
 
 .el-pager li:hover {
 	color: #42b983;
 }
 
 .el-pagination .btn-next,
 .el-pagination .btn-prev {
 	border: 1px solid #EBEEF5;
 	height: 20px;
 	line-height: 20px;
 }
 
 .el-pagination {
 	display: flex;
 	align-items: center;
 	justify-content: flex-end;
 }
 
 .el-pagination button:hover {
 	color: #42b983;
 }
 .ye2,
 .ye1 {
 	border: 1px solid #EBEEF5;
 	height: 20px;
 	line-height: 20px;
 	padding: 0 4px;
 	color: #999999;
 	font-weight: 700;
 }
 
 .ye1 {
 	padding: 0 8px;
 }
 
 .ye1:hover,
 .ye2:hover {
 	color: #42b983;
 }
</style>
